import { Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

import { PackageCategoryPipe } from './package-category.pipe';

import { DeepPartial } from '@iss/wo-common/types';
import { PackageCategory } from '@iss/wo-common/trade-off';

type PackageDescriptionPipeInput = DeepPartial<{
  readonly packageCategory: Maybe<PackageCategory>;
  readonly packageDescription: Maybe<string>;
}>;

@Pipe({ name: 'package', pure: false, standalone: true })
export class PackagePipe implements PipeTransform {
  private readonly packageCategoryPipe = new PackageCategoryPipe();

  public transform(value: Maybe<PackageDescriptionPipeInput>): string {
    return [ this.packageCategoryPipe.transform(value?.packageCategory), value?.packageDescription ].filter(Boolean).join(' - ');
  }
}
